import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Location } from '@angular/common';

import { PortalBookingNode } from '@app/services/api/api.types';
import { TravelerInfoBlocks } from '@app/components/traveler-info/traveler-info.enum';

@Component({
  selector: 'booking-hotel',
  templateUrl: './booking-hotel.component.html',
  styleUrls: ['./booking-hotel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingHotelComponent {
  @Input() data: PortalBookingNode | null = null;

  private location = inject(Location);

  protected guestFields = [
    TravelerInfoBlocks.FirstName,
    TravelerInfoBlocks.MiddleName,
    TravelerInfoBlocks.LastName,
    TravelerInfoBlocks.PhoneNumber,
    TravelerInfoBlocks.Email,
  ];

  goBack() {
    this.location.back();
  }
}
